import { useContext, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ProductContext } from "../context/ProductContext";
import HomeMain from "../layouts/main/HomeMain";

import { Helmet } from "react-helmet-async";

const Container = styled.article`
  color: ${(props) => props.theme.textColor};
`;
const Section = styled.section`
  height: 100vh;
`;
const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
const Home = () => {
  const { t, i18n } = useTranslation();
  const { loadProducts } = useContext(ProductContext);

  useEffect(() => {
    loadProducts();
  }, [i18n.language]);

  const seoData = {
    en: {
      title: "Buy Nicotine Pouches Online – Strong & Flavored Snus | SnusCo",
      description:
        "Order premium nicotine pouches with strong and refreshing flavors – shipped from Austria to all of Europe. Choose your favorite brands and enjoy fast delivery!",
      keywords:
        "nicotine pouches, snus, buy nicotine pouches, snus Austria, order snus Europe, strong nicotine pouches, flavored snus",
      ogTitle: "Buy Nicotine Pouches Online – Strong & Flavored Snus | SnusCo",
      ogDescription:
        "Shop the best nicotine pouches online at SnusCo. Fast delivery across Europe from our Austrian warehouse. Explore top brands and flavors.",
      twitterTitle:
        "Buy Nicotine Pouches – Fast Shipping Across Europe | SnusCo",
      twitterDescription:
        "Discover strong and refreshing nicotine pouches. Shipped from Austria, delivered across Europe. Shop now at SnusCo!",
      url: "https://www.snusco.eu/",
      image: "https://www.snusco.eu/images/snuspouch.jpg",
      locale: "en",
    },
    de: {
      title: "Snus & Nikotinbeutel online kaufen – Starke Aromen | SnusCo",
      description:
        "Bestellen Sie hochwertige Nikotinbeutel mit intensiven Aromen – direkt aus Österreich, europaweit geliefert. Entdecken Sie starke Marken und schnelle Lieferung!",
      keywords:
        "Nikotinbeutel, Snus kaufen, Nikotinsnus, starke Aromen, Snus Europa, SnusCo",
      ogTitle: "Snus & Nikotinbeutel online kaufen – Starke Aromen | SnusCo",
      ogDescription:
        "Kaufen Sie Snus und Nikotinbeutel online bei SnusCo. Schneller Versand aus Österreich in ganz Europa. Jetzt entdecken!",
      twitterTitle:
        "Nikotinbeutel & Snus – Schnell geliefert in Europa | SnusCo",
      twitterDescription:
        "Entdecken Sie starke und aromatische Nikotinbeutel. Versand aus Österreich in ganz Europa. Jetzt online bestellen bei SnusCo!",
      url: "https://www.snusco.eu/",
      image: "https://www.snusco.eu/images/snuspouch.jpg",
      locale: "de",
    },
  };

  const currentSeo = seoData[i18n.language] || seoData.en;

  return (
    <>
      <Helmet>
        {/* Meta Title */}
        <title>{currentSeo.title}</title>

        {/* Meta Description */}
        <meta name="description" content={currentSeo.description} />

        {/* Meta Keywords */}
        <meta name="keywords" content={currentSeo.keywords} />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content={currentSeo.ogTitle} />
        <meta property="og:description" content={currentSeo.ogDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={currentSeo.url} />
        <meta property="og:image" content={currentSeo.image} />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={currentSeo.twitterTitle} />
        <meta
          name="twitter:description"
          content={currentSeo.twitterDescription}
        />
        <meta name="twitter:image" content={currentSeo.image} />

        {/* Canonical Link */}
        <link rel="canonical" href={currentSeo.url} />

        {/* Additional Meta Tags */}
        <meta property="og:locale" content={currentSeo.locale} />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <HomeMain />
    </>
  );
};

export default Home;
